export const altContractFunction = funktion => ({
    type: 'ALT_CONTRACT_FUNCTION',
    payload: funktion
});

export const altInvoiceFunction = funktion => ({
    type: 'ALT_INVOICE_FUNCTION',
    payload: funktion
});